import * as React from 'react'
import { Box, Typography, Link, Tooltip } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { CopyTextLink } from 'components/CopyTextLink'

interface ActivationPinProps {
  deviceName: string
  devicePin: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    activation: {
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(8),
    },
  }),
)

export const ActivationPin: React.FunctionComponent<ActivationPinProps> = ({
  deviceName,
  devicePin,
}) => {
  const classes = useStyles({})

  return (
    <Box>
      <Typography variant="h4" className={classes.activation}>
        Activation Key for {deviceName}
      </Typography>
      <CopyTextLink
        link={devicePin}
        tooltip="Copy activation key to clipboard."
      />
    </Box>
  )
}
